/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Injector,
  Input,
} from '@angular/core';

import { GridFeature, GridHoverOptionBarFeature, GridOptionBarFeature } from '../../features';
import { AbstractGridOptionBarFeature } from '../../features/option-bar/abstract-grid-option-bar-feature';
import { GridOptionBarTemplateDirective } from './grid-option-bar-template.directive';

@Component({
  standalone: false,
  selector: 'gh-grid-option-bar',
  template: '',
  providers: [GridOptionBarFeature, GridHoverOptionBarFeature],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridOptionBarComponent implements AfterContentInit {
  @Input() showOnHover: boolean;

  @ContentChild(GridOptionBarTemplateDirective, { static: false }) template: GridOptionBarTemplateDirective;

  private _suppressedEvents: string[] = ['click'];

  private feature: AbstractGridOptionBarFeature;

  constructor(private injector: Injector) {

  }

  @Input()
  set suppressedEvents(events: string | string[]) {
    this._suppressedEvents = Array.isArray(events) ? events : events.split(' ');
  }

  ngAfterContentInit(): void {
    this.feature = this.showOnHover
      ? this.injector.get(GridHoverOptionBarFeature)
      : this.injector.get(GridOptionBarFeature);

    this.feature.setSuppressedEvents(this._suppressedEvents);
    this.feature.setTemplateRef(this.template.template);
  }

  getFeature(): GridFeature {
    return this.feature;
  }
}
